// breadcrumbConfig.js

import { NavLink,useSearchParams,useLocation,useNavigate } from "react-router-dom";
import { Typography, Link } from "@mui/material";
import { MdKeyboardArrowDown } from "react-icons/md";
import Cookies from "js-cookie";
import { cssProperties } from "../utils/commonCssProperties";
import { DecryptObjectFunction, EncryptObjectFunction,DecryptFunction } from "../utils/cryptoFunction";

const project = sessionStorage.getItem("mhet_cnd_project");

const css = {
  color: cssProperties?.fontcolor?.primary,
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  textDecoration: "none",
  cursor: "default",
   pointerEvents: "none"
};
const css2={
display: 'flex', 
alignItems: 'center',
 gap: '12px'

}
export default function useBreadcrumbs() {
     const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const project = sessionStorage.getItem("mhet_cnd_project");
    const coursenameFromUrl = location.state?.coursename
    const coursename = coursenameFromUrl && coursenameFromUrl!=="undefined"?coursenameFromUrl :(  sessionStorage.getItem("coursename") ? sessionStorage.getItem("coursename") : searchParams.get("coursename"));
    const courseid = searchParams.get("courseid");
    const page = searchParams.get("page");
   
    
    const pathname = location.pathname;
    const encryptedData = searchParams.get("c_data");
    const decrypted = DecryptObjectFunction(encryptedData);
    const courseName = decrypted?.coursename;
    const edit = decrypted?.edit;
    const courseIdVal = decrypted?.courseid;
    // console.log(coursename);
  
    const encryptedParams = {
      courseid: courseIdVal,
      coursename: courseName,
      edit: edit
    };

    // console.log(typeof coursename,coursename,"undefined consoeld")
  
    const breadcrumbs = {
    
    [`/${project}/registration`]: [
        <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
          Dashboard 
        </Link>,
        <Typography key="2" sx={{ ...css, ...css2, fontWeight: "bold" }}>
          Profile <MdKeyboardArrowDown size={16} />
        </Typography>,
      ],
  [`/${project}/admit-card-list`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard
    </Link>,
    <Typography key="2" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      Admit card list <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],
  [`/${project}/admit-card`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard
    </Link>,
    <Link key="2" underline="hover" component={"span"} to={`/${project}/admit-card-list`} sx={css}>
      Admit card list
    </Link>,
    <Typography key="3" sx={{ ...css,...css2, fontWeight: "bold"
                    }}>
      Admit card <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],
  [`/${project}/answer-key`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard
    </Link>,
    // <Typography key="2" sx={{ ...css, ...css2, fontWeight: "bold" }}>
    //   Answer Key <MdKeyboardArrowDown size={16} />
    // </Typography>,
     page === "answerlist" ? 
        (
          <Typography
            key="2"
            color="text.primary"
            sx={{...css,...css2,fontWeight:"bold"}}
          >
            Answer Key List
            <MdKeyboardArrowDown size={16} />
          </Typography>
        ) : page === "tablelist" ? 
        (
          <Typography
            key="3"
            color="text.primary"
            sx={{...css,...css2,fontWeight:"bold"}}
          >
            Answer Key
            <MdKeyboardArrowDown size={16} />
          </Typography>
        ) : page === "objectiontracker" ? (
          <Typography
            key="3"
            color="text.primary"
            sx={{...css,...css2,fontWeight:"bold"}}
          >
            Objection Tracker
            <MdKeyboardArrowDown size={16} />
          </Typography>
        ) : page === "raisedobjection" ? (
            <Typography
            key="3"
            color="text.primary"
            sx={{...css,...css2,fontWeight:"bold"}}
            onClick={()=>navigate(`/${project}/answer-key?page=objectiontracker`)}
          >
            Objection Tracker
          </Typography> ) : (
          <Typography
            key="3"
            color="text.primary"
            sx={{...css,...css2,fontWeight:"bold"}}
          >
            Raised Objection
            <MdKeyboardArrowDown size={16} />
          </Typography>
        ) 
  ],
  [`/${project}/course-selection`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard
    </Link>,
    <Typography key="2" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      Course selection <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],
  
  [`/${project}/instruction`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard
    </Link>,
    <Link key="2" underline="hover" component={"span"} to={`/${project}/course-selection`} sx={css}>
      Course selection
    </Link>,
    <Link key="3" underline="hover" component={"span"} to={`/${project}/course-registration`} sx={css}>
      Course registration
    </Link>,
    <Link key="4" underline="hover" component={"span"} to={`/${project}/confirm-payment`} sx={css}>
      Payment confirmation
    </Link>,
    <Typography key="5" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      Instructions <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],

  [`/${project}/objection-details`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard
    </Link>,
    <Link key="2" underline="hover" component={"span"} to={`/${project}/answer-key?page=tablelist`} sx={css}>
      Answer Key
    </Link>,
    <Link key="3" underline="hover" component={"span"} to={`/${project}/answer-key?page=objectiontracker`} sx={css}>
      Objection Tracker
    </Link>,
    <Link key="4" underline="hover" component={"span"} to={`/${project}/answer-key?page=raisedobjection`} sx={css}>
      Raised Objection
    </Link>,
    <Typography key="5" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      Objection Details <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],

  [`/${project}/payment-receipt-view/:id`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard
    </Link>,
    <Link key="2" underline="hover" component={"span"} to={`/${project}/payment-receipts`} sx={css}>
      Payment Receipts List
    </Link>,
    <Typography key="3" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      Payment Receipt <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],

  [`/${project}/payment-receipts`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard
    </Link>,
    <Typography key="2" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      Payment Receipts <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],

  [`/${project}/pre-request`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard
    </Link>,
    <Link key="2" underline="hover" component={"span"} to={`/${project}/course-selection`} sx={css}>
      Course selection
    </Link>,
    <Typography key="3" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      Pre Request Page <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],
  [`/${project}/query-list`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard
    </Link>,
    <Typography key="2" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      Your Query Status <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],
  [`/${project}/course-registration`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard 
    </Link>,
    <Link
      key="2"
      underline="hover"
      component={"span"}
      to={
        edit
          ? `/${project}/editing-facility?c_data=${EncryptObjectFunction(encryptedParams)}` 
          : `/${project}/course-selection`
      }
      sx={css}
    >
      {edit ? "Edit Details" : "Course selection"} 
    </Link>,
    <Typography key="3" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      {coursename || courseName}
    </Typography>,
  ],
  [`/${project}/cap-landingpage`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard 
    </Link>,
    <Link
      key="2"
      underline="hover"
      component={"span"}
      to={ edit ? `/${sessionStorage.getItem("mhet_cnd_project")}/editing-facility?c_data=${EncryptObjectFunction(encryptedParams)}` : `/${sessionStorage.getItem("mhet_cnd_project")}/course-selection`}
      sx={css}
    >
      {edit ? "Edit Details" : "Course selection"} 
    </Link>,
    <Typography key="3" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      {/* {coursename || courseName} */}
      {coursename || courseName}
    </Typography>,
  ],
    [`/${project}/cap-registration`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard 
    </Link>,
    <Typography key="2" sx={{ ...css, ...css2, fontWeight: "bold" }}>
     Cap Registration <MdKeyboardArrowDown size={16} />
    </Typography>,
    
  ],
  [`/${project}/editing-facility`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard 
    </Link>,
    <Link
      key="2"
      underline="hover"
      component={"span"}
      to={
           `/${project}/course-selection`
      }
      sx={css}
    >
      Course selection
    </Link>,
    <Typography key="3" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      {courseName} <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],
  [`/${project}/objection-confirm-payment`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard 
    </Link>,
    <Link
      key="2"
      underline="hover"
      component={"span"}
      to={
        edit
          ? `/${project}/editing-facility?c_data=${EncryptObjectFunction(encryptedParams)}`
          : `/${project}/course-selection`
      }
      sx={css}
    >
      {edit ? "Edit Details" : "Course selection"} 
    </Link>,
     !edit && (
        <Link
          underline="hover"
          key="course-name"
          onClick={() =>
            navigate(
              `/${project}/course-registration?page=personalinformation`,
              {
                state: {
                  courseid: courseid || courseIdVal,
                  coursename:  coursename || courseName,
                },
              }
            )
          }
          sx={css}
        >
          {coursename || courseName}
        </Link>
      ),
    <Typography key="3" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      Course Registration <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],
  [`/${project}/payment-confirmation`]: [
    <Link
      key="1"
      underline="hover"
      component={"span"}
      to={`/${project}/home`}
      sx={css}
    >
      Dashboard
    </Link>,
  
    <Link
      key="2"
      underline="hover"
      component={"span"}
      to={
        edit
          ? `/${project}/editing-facility?c_data=${EncryptObjectFunction(encryptedParams)}`
          : `/${project}/course-selection`
      }
      sx={css}
    >
      {edit ? "Edit Details" : "Course selection"}
    </Link>,
  
    !edit && (
      <Link
        key="course-name"
        underline="hover"
        onClick={() =>
          navigate(`/${project}/course-registration?page=personalinformation`, {
            state: {
              courseid: courseid || courseIdVal,
              coursename: coursename || courseName,
            },
          })
        }
        sx={css}
      >
        {coursename || courseName}
      </Link>
    ),
  
    <Typography key="3" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      Payment confirmation <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],
  


  
 
  [`/${project}/raise-query`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard
    </Link>,
    <Link key="2" underline="hover" component={"span"} to={`/${project}/query-list`} sx={css}>
      Your Query Status
    </Link>,
    <Typography key="3" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      Raise a Query <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],
  
  
  [`/${project}/score-card`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard
    </Link>,
    <Link key="2" underline="hover" component={"span"} to={`/${project}/score-card-list`} sx={css}>
      Score card list
    </Link>,
    <Typography key="3" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      Score card <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],
  
 
  [`/${project}/score-card-list`]: [
    <Link key="1" underline="hover" component={"span"} to={`/${project}/home`} sx={css}>
      Dashboard
    </Link>,
    <Typography key="2" sx={{ ...css, ...css2, fontWeight: "bold" }}>
      Score card list <MdKeyboardArrowDown size={16} />
    </Typography>,
  ],
  
  // ... Add more entries for each route here
}
return breadcrumbs[pathname] || [];
}
